






import Component from 'vue-class-component';
import { sensorApi } from '@/context/sensor/api/SensorApi';

import { SensorFormModel } from '@/context/sensor/model/SensorFormModel';
import { FormContainer } from '@/common/mixin/FormContainer';
import SensorUpdateForm from '@/context/sensor/component/form/SensorUpdateForm.vue';

@Component({
  components: { SensorUpdateForm }
})
export default class SensorUpdateContainer extends FormContainer<SensorFormModel> {
  model: SensorFormModel = new SensorFormModel();
  id: number = Number(this?.$route?.params?.id);

  async formApi(): Promise<SensorFormModel> {
    const response: SensorFormModel = await sensorApi.form<SensorFormModel>(SensorFormModel, {
      id: this.id
    });
    return response;
  }
}
